module.exports = __webpack_public_path__ + "static/media/besteron-b-red.eea837f5.svg";